import { useTranslation } from "react-i18next";
import SettingsListItem from "../../../molecules/settings/SettingsListItem";
import { useContext, useEffect } from "react";
import { AuthContext } from "../../../../context/authContext";
import ContactContent from "../../../molecules/contactContent/ContactContent";
import Text from "../../../molecules/content/Text";
import { attrArrayToMap, getCountryCode } from "../../../../helpers/utils";
import DeleteAccountLinkButton from "../../../molecules/buttons/DeleteAccountLinkButton";

const AccountInfoSection = () => {
  const { t } = useTranslation();
  const countryCode = getCountryCode();
  const { attrInfo, getSessionInfo } = useContext(AuthContext);
  const attrMap = attrArrayToMap(attrInfo);

  useEffect(() => {
    getSessionInfo();
  }, []);

  return (
    <div className="flex flex-col gap-20 pb-10">
      <div className="flex flex-col gap-4">
        <SettingsListItem
          label={t("home.nameSurname")}
          text={`${attrMap["given_name"]} ${attrMap["family_name"]}`}
          to="/change-profile"
        />
        <SettingsListItem
          label={t("home.email")}
          text={attrMap["email"]}
          to="/change-email"
        />
        <SettingsListItem
          label={t("home.phoneNumber")}
          text={attrMap["phone_number"]}
          to="/change-phone"
        />
        <SettingsListItem
          label={t("home.changePassword")}
          to="/change-password"
        />
      </div>
      <div className="flex flex-col gap-4">
        <Text
          variant="semibold"
          className="flex justify-center text-vestelColor"
        >
          {t("accountInfo.description")}
        </Text>
        <ContactContent countryCode={countryCode} />
        <DeleteAccountLinkButton />
      </div>
    </div>
  );
};

export default AccountInfoSection;
